"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var renderRoot_1 = require("../renderRoot");
var notificationsStore_1 = require("./storage/notificationsStore");
var NotificationNavBadge = function () {
    var count = (0, notificationsStore_1.useUnreadCount)();
    if (count <= 0)
        return null;
    return react_1.default.createElement("sup", { className: "msia-nav-notification-badge" }, count > 99 ? '99+' : count);
};
var badgeTargetIds = [
    'nav-notification-badge-desktop',
    'nav-notification-badge-mobile',
    'nav-notification-menu-badge-desktop',
    'nav-notification-menu-badge-mobile',
];
window.msiaInitNavBadge = function (unreadCount) {
    if (!(0, notificationsStore_1.isNotificationsInitialised)()) {
        (0, notificationsStore_1.initUnreadCount)({ userId: 0, unreadCount: unreadCount });
    }
    for (var _i = 0, badgeTargetIds_1 = badgeTargetIds; _i < badgeTargetIds_1.length; _i++) {
        var id = badgeTargetIds_1[_i];
        var el = document.getElementById(id);
        if (el)
            (0, renderRoot_1.renderInto)(el, react_1.default.createElement(NotificationNavBadge, null));
    }
};
